export function getDurationUnits(durationUnit) {
    switch (durationUnit) {
        case 1:
            return "Seconds";
        case 2:
            return "Minutes";
        case 3:
            return "Hour";
        case 4:
            return "Week";
        case 5:
            return "Month";
        case 6:
            return "Year";
        default:
            return "UNKOWN";
    }
}  


// WEBPACK FOOTER //
// ./src/utils/durationUnits.js